/* eslint-disable react/prop-types */
import React from 'react';
import { message, Upload } from 'antd';
import { putObject } from '@/utils/upload';
import { UploadOutlined } from '@ant-design/icons';
import AttentionTip from '@/components/attentionTip';
/**
 *
 * @param props
 * @params mode 模式 支持单张和多张上传
 *
 * @returns {JSX.Element}
 */
// eslint-disable-next-line react/display-name
export default (props) => {
  const {
    mode = 'single',
    uploadMultiple = false, // 是否支持多选，默认单选
    isSupportGif = true, // 是否支持Gif，默认支持
    imgList,
    setImgList,
    isFlip, // 排序是否翻转，‘true’ 倒序（新传照片在前）  ‘false’ 正序（新传照片在后）
    text,
    maxSize,
    customMaxCount = 9,
    maxHeight,
    maxWidth,
    //  是否限制图片的尺寸
    limitPicSize,
    whRatio,
    btnText,
  } = props;
  //  固定宽高校验
  let fixedWidth;
  let fixedHeight;
  if (limitPicSize) {
    [fixedWidth, fixedHeight] = limitPicSize.split('*');
    fixedWidth = Number(fixedWidth);
    fixedHeight = Number(fixedHeight);
  }
  const onDelete = (file) => {
    const index = imgList.findIndex((item) => item.url === file.url);
    const cache = [...imgList];
    cache.splice(index, 1);
    setImgList(cache);
  };

  const beforeUpload = ({ file, onProgress, onError, onSuccess }) => {
    if (maxWidth || maxHeight) {
      checkImageSize({ file, onProgress, onError, onSuccess });
    } else if (fixedHeight || fixedWidth) {
      checkFixedSize({ file, onProgress, onError, onSuccess });
    } else if (whRatio) {
      console.log('whRatio', whRatio);
      checkImageRadio({ file, onProgress, onError, onSuccess });
    } else {
      customRequest({ file, onProgress, onError, onSuccess });
    }
  };

  //  检查图片的固定宽高
  const checkFixedSize = ({ file, onProgress, onError, onSuccess }) => {
    const filereader = new FileReader();
    filereader.readAsDataURL(file);
    filereader.onload = (e) => {
      const src = e.target.result;
      const image = new Image();
      image.src = src;
      image.onload = function (e) {
        console.log(this.width + '*' + this.height);
        if (this.width !== fixedWidth || this.height !== fixedHeight) {
          // 上传图片的宽高与传递过来的限制宽高作比较，超过限制则调用失败回调
          message.warn(
            '图片尺寸需为：' + fixedWidth + 'px' + '*' + fixedHeight + 'px',
          );
          // return;
        }
        customRequest({ file, onProgress, onError, onSuccess });
      };
    };
  };
  const checkImageSize = ({ file, onProgress, onError, onSuccess }) => {
    const filereader = new FileReader();
    filereader.readAsDataURL(file);
    filereader.onload = (e) => {
      const src = e.target.result;
      const image = new Image();
      image.src = src;
      image.onload = function (e) {
        console.log(this.width + '*' + this.height);
        if (this.width > maxWidth && this.height > maxHeight) {
          // 上传图片的宽高与传递过来的限制宽高作比较，超过限制则调用失败回调
          message.warn('图片最大' + maxWidth + 'px' + '*' + maxHeight + 'px');
          return;
        } else if (this.width > maxWidth) {
          message.warn('图片宽度不能超过' + maxWidth + 'px');
          return;
        } else if (this.height > maxHeight) {
          message.warn('图片高度不能超过' + maxHeight + 'px');
          return;
        }
        customRequest({ file, onProgress, onError, onSuccess });
      };
    };
  };

  const checkImageRadio = ({ file, onProgress, onError, onSuccess }) => {
    const filereader = new FileReader();
    filereader.readAsDataURL(file);
    filereader.onload = (e) => {
      const src = e.target.result;
      const image = new Image();
      image.src = src;
      image.onload = function (e) {
        console.log(
          '宽高',
          this.width + '/' + this.height,
          this.width / this.height,
        );
        if ((this.width / this.height).toFixed(2) !== whRatio.toFixed(2)) {
          // 上传图片的宽高与传递过来的限制宽高作比较，超过限制则调用失败回调
          message.warn('图片宽高比' + this.width + ':' + this.height);
          return;
        }
        customRequest({ file, onProgress, onError, onSuccess });
      };
    };
  };

  const customRequest = ({ file, onProgress, onError, onSuccess }) => {
    if (maxSize && file.size > maxSize) {
      if (maxSize < 1024 * 1024) {
        // 小于1MB 使用KB
        message.warn('图片大小不能超过' + Math.floor(maxSize / 1024) + 'KB');
      } else {
        message.warn(
          '图片大小不能超过' + Math.floor(maxSize / (1024 * 1024)) + 'M',
        );
      }
      return;
    }

    const fileType = file.name.substring(file.name.lastIndexOf('.') + 1);
    let types = ['PNG', 'JPG', 'JPEG', 'GIF'];
    if (!isSupportGif) {
      types = ['PNG', 'JPG', 'JPEG'];
    }
    if (!types.includes(fileType.toUpperCase())) {
      message.warn('不支持此类型文件！');
      return;
    }
    putObject({
      filename: file.name,
      file,
      onProgress,
      callback: (err, data) => {
        if (err) {
          onError(err);
        }
        if (data) {
          const da = {
            percent: 1,
            name: file.name,
            thumbUrl: `https://${data.Location}`,
            url: `https://${data.Location}`,
          };
          if (mode === 'single') {
            setImgList([da]);
          } else {
            setImgList((previous) => {
              if (previous.length == customMaxCount) {
                previous.pop();
              }

              if (isFlip === 'true') {
                return [da, ...previous];
              } else {
                return [...previous, da];
              }
            });
          }
          onSuccess(data);
        }
      },
    });
  };

  return (
    <AttentionTip text={text || ''}>
      <Upload
        fileList={imgList}
        accept={isSupportGif ? '.png, .jpg, .jpeg, .gif' : '.png, .jpg, .jpeg'}
        maxCount={mode === 'single' ? 1 : customMaxCount}
        listType={'picture-card'}
        multiple={uploadMultiple}
        onRemove={onDelete}
        customRequest={beforeUpload}
      >
        <UploadOutlined />
        {btnText || '点击上传'}
      </Upload>
    </AttentionTip>
  );
};
